module.exports = __webpack_public_path__ + "media/images/video/yogasix-app-promo-78296d6e7d170d6a0c05426c4a83743b.png";